export const GET_MISC_SETTINGS_SUCCESS = "GET_MISC_SETTINGS_SUCCESS";
export const GET_MISC_SETTINGS_FAILURE = "GET_MISC_SETTINGS_FAILURE";

export const UPDATE_MISC_SETTINGS_SUCCESS = "UPDATE_MISC_SETTINGS_SUCCESS";
export const UPDATE_MISC_SETTINGS_FAILURE = "UPDATE_MISC_SETTINGS_FAILURE";

export const AI_TRAINING_SUCCESS = "AI_TRAINING_SUCCESS";
export const AI_TRAINING_FAILURE = "AI_TRAINING_FAILURE";

export const HONORING_SUCCESS = "HONORING_SUCCESS";
export const HONORING_FAILURE = "HONORING_FAILURE";

export const HEADS_SUCCESS = "HEADS_SUCCESS";
export const HEADS_FAILURE = "HEADS_FAILURE";

export const ADD_MANUAL_AUTHORIZATION_SUCCESS =
  "ADD_MANUAL_AUTHORIZATION_SUCCESS";
export const ADD_MANUAL_AUTHORIZATION_FAILURE =
  "ADD_MANUAL_AUTHORIZATION_FAILURE";

export const GET_MANUAL_AUTHORIZATION_SUCCESS =
  "GET_MANUAL_AUTHORIZATION_SUCCESS";
export const GET_MANUAL_AUTHORIZATION_FAILURE =
  "GET_MANUAL_AUTHORIZATION_FAILURE";

export const DELETE_MANUAL_AUTHORIZATION_SUCCESS =
  "DELETE_MANUAL_AUTHORIZATION_SUCCESS";
export const DELETE_MANUAL_AUTHORIZATION_FAILURE =
  "DELETE_MANUAL_AUTHORIZATION_FAILURE";
